const curriculumByIdData = [
  {
    subject: "History",
    supportedInQL: true,
    grade: "5",
    updatedAt: "2025-05-19T14:48:24Z",
    createdAt: "2025-05-19T14:48:24Z",
    longCourseName: "5th Grade History (United States History\nand Geography: Making a New Nation)",
    courseName: "United States History and Geography: Making a New Nation",
    courseImage: "https://ql-course-images.s3.us-west-2.amazonaws.com/History/5H.jpg",
    id: "5H",
    curriculumSource: "ca_board_of_education",
    isPremiumCourse: false,
    isUpcomingCourse: false,
    units: [
      {
        unit: "The American Revolution",
        isQLCharacter: true,
        grade: "5",
        lessonMasteryScore: 5,
        metaverse: "benjamin_franklin",
        qlUnitDescription: "Causes, key events, and aftermath of the American Revolution",
        unitUrl: "https://ql-unit-json.s3.us-west-2.amazonaws.com/Demo/demo_unit.json",
        createdAt: "2025-05-19T14:48:24Z",
        updatedAt: "2025-05-19T14:48:24Z",
        curriculumId: "cf1589c9-ba2d-4b8a-be62-075433e82a59",

        unitId: "ba973689-77ce-4f4c-aa61-b9f01bb4c8fa",
        qlUnit: "The American Revolution",
        tutor: "Benjamin Franklin",
        unitImage: "https://ql-unit-images.s3.us-west-2.amazonaws.com/History/5H_P6.jpg",
        lessons: [
          {
            id: "910d23c6-ded9-4e4f-8640-8da328801f04",
            lessonId: "5H_P6_L1",
            unitId: "ba973689-77ce-4f4c-aa61-b9f01bb4c8fa",
            subject: "History",
            lessonName: "Key Battles of Revolution",
            grade: "5",
            content: "video",
            topicId: "5.6.A",
            topic: "Students understand the course and consequences of the American Revolution.",
            duration: 3.638419,
            totalSlides: 9,
            lessonDescription: "Identify and map the major military battles, campaigns, and turning points of the Revolutionary War, the roles of the American and British leaders, and the Indian leaders' alliances on both sides.",
            clarificationStatement: "",
            assessmentBoundry: "",
            lexileLevel: "925L",
            anchorStandardId: "",
            anchorStandardDescription: "",
            detailStandardId: "5.6.1",
            detailStandardDescription: "Identify and map the major military battles, campaigns, and turning points of the Revolutionary War, the roles of the American and British leaders, and the Indian leaders' alliances on both sides.",
            quiklearnLessonToDetailMapId: "5.6.1",
            chronologicalAndSpatialThinking: [
              "Students place key events and people of the historical era they are studying in a chronological sequence and within a spatial context; they interpret time lines.",
              "Students correctly apply terms related to time, including past, present, future, decade, century, and generation.",
              "Students explain how the present is connected to the past, identifying both similarities and differences between the two, and how some things change over time and some things stay the same.",
              "Students use map and globe skills to determine the absolute locations of places and interpret information available through a map’s or globe’s legend, scale, and symbolic representations.",
              "Students judge the significance of the relative location of a place (e.g., proximity to a harbor, on trade routes) and analyze how relative advantages or disadvantages can change over time."
            ],
            researchEvidenceAndPointOfView: [
              "Students differentiate between primary and secondary sources.",
              "Students pose relevant questions about events they encounter in historical documents, eyewitness accounts, oral histories, letters, diaries, artifacts, photographs, maps, artworks, and architecture.",
              "Students distinguish fact from fiction by comparing documentary sources on historical figures and events with fictionalized characters and events."
            ],
            historicalInterpretation: [
              "Students summarize the key events of the era they are studying and explain the historical contexts of those events.",
              "Students identify the human and physical characteristics of the places they are studying and explain how those features form the unique character of those places.",
              "Students identify and interpret the multiple causes and effects of historical events.",
              "Students conduct cost-benefit analyses of historical and current events."
            ],
            createdAt: "2025-05-19T14:48:24Z",
            updatedAt: "2025-05-19T14:48:24Z",
            progress: 0,
            masteryScore: 0,
            masteryStatus: "NOT_STARTED"
          },
          {
            id: "a91cff67-4b16-473c-bfff-2168686c3c22",
            lessonId: "5H_P6_L2",
            unitId: "ba973689-77ce-4f4c-aa61-b9f01bb4c8fa",
            subject: "History",
            lessonName: "Allies in Revolution",
            grade: "5",
            content: "video",
            topicId: "5.6.A",
            topic: "Students understand the course and consequences of the American Revolution.",
            duration: 3.897901,
            totalSlides: 10,
            lessonDescription: "Describe the contributions of France and other nations and of individuals to the outcome of the Revolution (e.g., Benjamin Franklin's negotiations with the French, the French navy, the Treaty of Paris, The Netherlands, Russia, the Marquis Marie Joseph de Lafayette, Tadeusz Kościuszko, Baron Friedrich Wilhelm von Steuben).",
            clarificationStatement: "",
            assessmentBoundry: "",
            lexileLevel: "925L",
            anchorStandardId: "",
            anchorStandardDescription: "",
            detailStandardId: "5.6.2",
            detailStandardDescription: "Describe the contributions of France and other nations and of individuals to the outcome of the Revolution (e.g., Benjamin Franklin's negotiations with the French, the French navy, the Treaty of Paris, The Netherlands, Russia, the Marquis Marie Joseph de Lafayette, Tadeusz Kościuszko, Baron Friedrich Wilhelm von Steuben).",
            quiklearnLessonToDetailMapId: "5.6.2",
            chronologicalAndSpatialThinking: [
              "Students place key events and people of the historical era they are studying in a chronological sequence and within a spatial context; they interpret time lines.",
              "Students correctly apply terms related to time, including past, present, future, decade, century, and generation.",
              "Students explain how the present is connected to the past, identifying both similarities and differences between the two, and how some things change over time and some things stay the same.",
              "Students use map and globe skills to determine the absolute locations of places and interpret information available through a map’s or globe’s legend, scale, and symbolic representations.",
              "Students judge the significance of the relative location of a place (e.g., proximity to a harbor, on trade routes) and analyze how relative advantages or disadvantages can change over time."
            ],
            researchEvidenceAndPointOfView: [
              "Students differentiate between primary and secondary sources.",
              "Students pose relevant questions about events they encounter in historical documents, eyewitness accounts, oral histories, letters, diaries, artifacts, photographs, maps, artworks, and architecture.",
              "Students distinguish fact from fiction by comparing documentary sources on historical figures and events with fictionalized characters and events."
            ],
            historicalInterpretation: [
              "Students summarize the key events of the era they are studying and explain the historical contexts of those events.",
              "Students identify the human and physical characteristics of the places they are studying and explain how those features form the unique character of those places.",
              "Students identify and interpret the multiple causes and effects of historical events.",
              "Students conduct cost-benefit analyses of historical and current events."
            ],
            createdAt: "2025-05-19T14:48:24Z",
            updatedAt: "2025-05-19T14:48:24Z",
            progress: 0,
            masteryScore: 0,
            masteryStatus: "NOT_STARTED"
          },
          {
            id: "e8814dc6-b5e1-41bc-ad10-0f8d03bb9895",
            lessonId: "5H_P6_L3",
            unitId: "ba973689-77ce-4f4c-aa61-b9f01bb4c8fa",
            subject: "History",
            lessonName: "Women's Roles in Revolution",
            grade: "5",
            content: "video",
            topicId: "5.6.A",
            topic: "Students understand the course and consequences of the American Revolution.",
            duration: 4.042881,
            totalSlides: 10,
            lessonDescription: "Identify the different roles women played during the Revolution (e.g., Abigail Adams, Martha Washington, Molly Pitcher, Phillis Wheatley, Mercy Otis Warren).",
            clarificationStatement: "",
            assessmentBoundry: "",
            lexileLevel: "925L",
            anchorStandardId: "",
            anchorStandardDescription: "",
            detailStandardId: "5.6.3",
            detailStandardDescription: "Identify the different roles women played during the Revolution (e.g., Abigail Adams, Martha Washington, Molly Pitcher, Phillis Wheatley, Mercy Otis Warren).",
            quiklearnLessonToDetailMapId: "5.6.3",
            chronologicalAndSpatialThinking: [
              "Students place key events and people of the historical era they are studying in a chronological sequence and within a spatial context; they interpret time lines.",
              "Students correctly apply terms related to time, including past, present, future, decade, century, and generation.",
              "Students explain how the present is connected to the past, identifying both similarities and differences between the two, and how some things change over time and some things stay the same.",
              "Students use map and globe skills to determine the absolute locations of places and interpret information available through a map’s or globe’s legend, scale, and symbolic representations.",
              "Students judge the significance of the relative location of a place (e.g., proximity to a harbor, on trade routes) and analyze how relative advantages or disadvantages can change over time."
            ],
            researchEvidenceAndPointOfView: [
              "Students differentiate between primary and secondary sources.",
              "Students pose relevant questions about events they encounter in historical documents, eyewitness accounts, oral histories, letters, diaries, artifacts, photographs, maps, artworks, and architecture.",
              "Students distinguish fact from fiction by comparing documentary sources on historical figures and events with fictionalized characters and events."
            ],
            historicalInterpretation: [
              "Students summarize the key events of the era they are studying and explain the historical contexts of those events.",
              "Students identify the human and physical characteristics of the places they are studying and explain how those features form the unique character of those places.",
              "Students identify and interpret the multiple causes and effects of historical events.",
              "Students conduct cost-benefit analyses of historical and current events."
            ],
            createdAt: "2025-05-19T14:48:24Z",
            updatedAt: "2025-05-19T14:48:24Z",
            progress: 0,
            masteryScore: 0,
            masteryStatus: "NOT_STARTED"
          },
          {
            id: "af2081ec-3143-413c-9b92-c241836d15f3",
            lessonId: "5H_P6_L4",
            unitId: "ba973689-77ce-4f4c-aa61-b9f01bb4c8fa",
            subject: "History",
            lessonName: "Revolutionary War Impact",
            grade: "5",
            content: "video",
            topicId: "5.6.A",
            topic: "Students understand the course and consequences of the American Revolution.",
            duration: 3.602281,
            totalSlides: 9,
            lessonDescription: "Understand the personal impact and economic hardship of the war on families, problems of financing the war, wartime inflation, and laws against hoarding goods and materials and profiteering.",
            clarificationStatement: "",
            assessmentBoundry: "",
            lexileLevel: "925L",
            anchorStandardId: "",
            anchorStandardDescription: "",
            detailStandardId: "5.6.4",
            detailStandardDescription: "Understand the personal impact and economic hardship of the war on families, problems of financing the war, wartime inflation, and laws against hoarding goods and materials and profiteering.",
            quiklearnLessonToDetailMapId: "5.6.4",
            chronologicalAndSpatialThinking: [
              "Students place key events and people of the historical era they are studying in a chronological sequence and within a spatial context; they interpret time lines.",
              "Students correctly apply terms related to time, including past, present, future, decade, century, and generation.",
              "Students explain how the present is connected to the past, identifying both similarities and differences between the two, and how some things change over time and some things stay the same.",
              "Students use map and globe skills to determine the absolute locations of places and interpret information available through a map’s or globe’s legend, scale, and symbolic representations.",
              "Students judge the significance of the relative location of a place (e.g., proximity to a harbor, on trade routes) and analyze how relative advantages or disadvantages can change over time."
            ],
            researchEvidenceAndPointOfView: [
              "Students differentiate between primary and secondary sources.",
              "Students pose relevant questions about events they encounter in historical documents, eyewitness accounts, oral histories, letters, diaries, artifacts, photographs, maps, artworks, and architecture.",
              "Students distinguish fact from fiction by comparing documentary sources on historical figures and events with fictionalized characters and events."
            ],
            historicalInterpretation: [
              "Students summarize the key events of the era they are studying and explain the historical contexts of those events.",
              "Students identify the human and physical characteristics of the places they are studying and explain how those features form the unique character of those places.",
              "Students identify and interpret the multiple causes and effects of historical events.",
              "Students conduct cost-benefit analyses of historical and current events."
            ],
            createdAt: "2025-05-19T14:48:24Z",
            updatedAt: "2025-05-19T14:48:24Z",
            progress: 0,
            masteryScore: 0,
            masteryStatus: "NOT_STARTED"
          },
          {
            id: "8b48fc66-0676-4dcd-b57d-bc65f7e916a9",
            lessonId: "5H_P6_L5",
            unitId: "ba973689-77ce-4f4c-aa61-b9f01bb4c8fa",
            subject: "History",
            lessonName: "State Constitutions' Revolutionary Influence",
            grade: "5",
            content: "video",
            topicId: "5.6.A",
            topic: "Students understand the course and consequences of the American Revolution.",
            duration: 3.472538,
            totalSlides: 9,
            lessonDescription: "Explain how state constitutions that were established after 1776 embodied the ideals of the American Revolution and helped serve as models for the U.S. Constitution.",
            clarificationStatement: "",
            assessmentBoundry: "",
            lexileLevel: "925L",
            anchorStandardId: "",
            anchorStandardDescription: "",
            detailStandardId: "5.6.5",
            detailStandardDescription: "Explain how state constitutions that were established after 1776 embodied the ideals of the American Revolution and helped serve as models for the U.S. Constitution.",
            quiklearnLessonToDetailMapId: "5.6.5",
            chronologicalAndSpatialThinking: [
              "Students place key events and people of the historical era they are studying in a chronological sequence and within a spatial context; they interpret time lines.",
              "Students correctly apply terms related to time, including past, present, future, decade, century, and generation.",
              "Students explain how the present is connected to the past, identifying both similarities and differences between the two, and how some things change over time and some things stay the same.",
              "Students use map and globe skills to determine the absolute locations of places and interpret information available through a map’s or globe’s legend, scale, and symbolic representations.",
              "Students judge the significance of the relative location of a place (e.g., proximity to a harbor, on trade routes) and analyze how relative advantages or disadvantages can change over time."
            ],
            researchEvidenceAndPointOfView: [
              "Students differentiate between primary and secondary sources.",
              "Students pose relevant questions about events they encounter in historical documents, eyewitness accounts, oral histories, letters, diaries, artifacts, photographs, maps, artworks, and architecture.",
              "Students distinguish fact from fiction by comparing documentary sources on historical figures and events with fictionalized characters and events."
            ],
            historicalInterpretation: [
              "Students summarize the key events of the era they are studying and explain the historical contexts of those events.",
              "Students identify the human and physical characteristics of the places they are studying and explain how those features form the unique character of those places.",
              "Students identify and interpret the multiple causes and effects of historical events.",
              "Students conduct cost-benefit analyses of historical and current events."
            ],
            createdAt: "2025-05-19T14:48:24Z",
            updatedAt: "2025-05-19T14:48:24Z",
            progress: 0,
            masteryScore: 0,
            masteryStatus: "NOT_STARTED"
          },
          {
            id: "71b79642-3f0c-42c2-8d54-273884dbfc23",
            lessonId: "5H_P6_L6",
            unitId: "ba973689-77ce-4f4c-aa61-b9f01bb4c8fa",
            subject: "History",
            lessonName: "Continental Congress Land Policies",
            grade: "5",
            content: "video",
            topicId: "5.6.A",
            topic: "Students understand the course and consequences of the American Revolution.",
            duration: 3.435533,
            totalSlides: 8,
            lessonDescription: "Demonstrate knowledge of the significance of land policies developed under the Continental Congress (e.g., sale of western lands, the Northwest Ordinance of 1787) and those policies' impact on American Indians' land.",
            clarificationStatement: "",
            assessmentBoundry: "",
            lexileLevel: "925L",
            anchorStandardId: "",
            anchorStandardDescription: "",
            detailStandardId: "5.6.6",
            detailStandardDescription: "Demonstrate knowledge of the significance of land policies developed under the Continental Congress (e.g., sale of western lands, the Northwest Ordinance of 1787) and those policies' impact on American Indians' land.",
            quiklearnLessonToDetailMapId: "5.6.6",
            chronologicalAndSpatialThinking: [
              "Students place key events and people of the historical era they are studying in a chronological sequence and within a spatial context; they interpret time lines.",
              "Students correctly apply terms related to time, including past, present, future, decade, century, and generation.",
              "Students explain how the present is connected to the past, identifying both similarities and differences between the two, and how some things change over time and some things stay the same.",
              "Students use map and globe skills to determine the absolute locations of places and interpret information available through a map’s or globe’s legend, scale, and symbolic representations.",
              "Students judge the significance of the relative location of a place (e.g., proximity to a harbor, on trade routes) and analyze how relative advantages or disadvantages can change over time."
            ],
            researchEvidenceAndPointOfView: [
              "Students differentiate between primary and secondary sources.",
              "Students pose relevant questions about events they encounter in historical documents, eyewitness accounts, oral histories, letters, diaries, artifacts, photographs, maps, artworks, and architecture.",
              "Students distinguish fact from fiction by comparing documentary sources on historical figures and events with fictionalized characters and events."
            ],
            historicalInterpretation: [
              "Students summarize the key events of the era they are studying and explain the historical contexts of those events.",
              "Students identify the human and physical characteristics of the places they are studying and explain how those features form the unique character of those places.",
              "Students identify and interpret the multiple causes and effects of historical events.",
              "Students conduct cost-benefit analyses of historical and current events."
            ],
            createdAt: "2025-05-19T14:48:24Z",
            updatedAt: "2025-05-19T14:48:24Z",
            progress: 0,
            masteryScore: 0,
            masteryStatus: "NOT_STARTED"
          },
          {
            id: "eb4add1a-c054-4d85-84ee-d249398a21f4",
            lessonId: "5H_P6_L7",
            unitId: "ba973689-77ce-4f4c-aa61-b9f01bb4c8fa",
            subject: "History",
            lessonName: "Revolutionary Ideals and Slavery",
            grade: "5",
            content: "video",
            topicId: "5.6.A",
            topic: "Students understand the course and consequences of the American Revolution.",
            duration: 3.621875,
            totalSlides: 8,
            lessonDescription: "Understand how the ideals set forth in the Declaration of Independence changed the way people viewed slavery.",
            clarificationStatement: "",
            assessmentBoundry: "",
            lexileLevel: "925L",
            anchorStandardId: "",
            anchorStandardDescription: "",
            detailStandardId: "5.6.7",
            detailStandardDescription: "Understand how the ideals set forth in the Declaration of Independence changed the way people viewed slavery.",
            quiklearnLessonToDetailMapId: "5.6.7",
            chronologicalAndSpatialThinking: [
              "Students place key events and people of the historical era they are studying in a chronological sequence and within a spatial context; they interpret time lines.",
              "Students correctly apply terms related to time, including past, present, future, decade, century, and generation.",
              "Students explain how the present is connected to the past, identifying both similarities and differences between the two, and how some things change over time and some things stay the same.",
              "Students use map and globe skills to determine the absolute locations of places and interpret information available through a map’s or globe’s legend, scale, and symbolic representations.",
              "Students judge the significance of the relative location of a place (e.g., proximity to a harbor, on trade routes) and analyze how relative advantages or disadvantages can change over time."
            ],
            researchEvidenceAndPointOfView: [
              "Students differentiate between primary and secondary sources.",
              "Students pose relevant questions about events they encounter in historical documents, eyewitness accounts, oral histories, letters, diaries, artifacts, photographs, maps, artworks, and architecture.",
              "Students distinguish fact from fiction by comparing documentary sources on historical figures and events with fictionalized characters and events."
            ],
            historicalInterpretation: [
              "Students summarize the key events of the era they are studying and explain the historical contexts of those events.",
              "Students identify the human and physical characteristics of the places they are studying and explain how those features form the unique character of those places.",
              "Students identify and interpret the multiple causes and effects of historical events.",
              "Students conduct cost-benefit analyses of historical and current events."
            ],
            createdAt: "2025-05-19T14:48:24Z",
            updatedAt: "2025-05-19T14:48:24Z",
            progress: 0,
            masteryScore: 0,
            masteryStatus: "NOT_STARTED"
          }
        ]
      }
    ]
  }
];
;
export default curriculumByIdData;
